import { AuxRadioGroup } from "@blk/aladdin-react-components-es";
import React from "react";
import { useDispatch } from "react-redux";
import { useWidgetComponentProps, useWidgetCurrentViewForm } from "components/widgets/hooks/use-current-widget";
import { language } from "language/default";
import { setCurrentStatusViewForm } from "store/current-dashboard";
import { ChartSelectValueFormatKind } from "store/current-dashboard/types";
const { amount, viewForm, multiple, percent } = language.en.skeleton.settingsMenu.viewForm;
const dataRadioViewForm = [
    { disabled: false, eventData: ChartSelectValueFormatKind.amount, label: amount },
    { disabled: false, eventData: ChartSelectValueFormatKind.multiple, label: multiple },
    { disabled: false, eventData: ChartSelectValueFormatKind.percent, label: percent }
];
export const InsSettingsViewForm = (props) => {
    const dispatch = useDispatch();
    const { sectionId, widgetId } = props;
    const currentViewForm = useWidgetCurrentViewForm(sectionId, widgetId);
    const settings = useWidgetComponentProps(sectionId, widgetId);
    const onRadioGroupChanged = (data) => {
        dispatch(setCurrentStatusViewForm({ sectionId, viewForm: data.detail.value.eventData, widgetId }));
    };
    dataRadioViewForm.forEach((e) => {
        e.checked = e.eventData === currentViewForm;
    });
    const filteredDataRadioViewForm = dataRadioViewForm
        .filter((item) => !settings?.userSettings?.viewFormExclude?.includes(ChartSelectValueFormatKind[item.eventData]));
    return React.createElement(AuxRadioGroup, { key: currentViewForm, data: filteredDataRadioViewForm, label: viewForm, isStacked: true, onRadioGroupChanged: onRadioGroupChanged });
};
